var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6441_460037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 0H0V7.30435H7.30435V0ZM6.26087 1.04348H1.04348V6.26087H6.26087V1.04348Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 0H8.34783V7.30435H15.6522V0ZM14.6087 1.04348H9.3913V6.26087H14.6087V1.04348Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0H16.6957V7.30435H24V0ZM22.9565 1.04348H17.7391V6.26087H22.9565V1.04348Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 8.34783H0V15.6522H7.30435V8.34783ZM6.26087 9.3913H1.04348V14.6087H6.26087V9.3913Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 8.34783H8.34783V15.6522H15.6522V8.34783ZM14.6087 9.3913H9.3913V14.6087H14.6087V9.3913Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8.34783H16.6957V15.6522H24V8.34783ZM22.9565 9.3913H17.7391V14.6087H22.9565V9.3913Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30435 16.6957H0V24H7.30435V16.6957ZM6.26087 17.7391H1.04348V22.9565H6.26087V17.7391Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6522 16.6957H8.34783V24H15.6522V16.6957ZM14.6087 17.7391H9.3913V22.9565H14.6087V17.7391Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.6957H16.6957V24H24V16.6957ZM22.9565 17.7391H17.7391V22.9565H22.9565V17.7391Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 2.08691H6.26085V6.26083H1.04346V2.08691Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 5.21735H14.6087V6.26083H9.39128V5.21735Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 12.5217H6.26085V14.6087H1.04346V12.5217Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 11.4782H14.6087V14.6087H9.39128V11.4782Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 17.7391H22.9565V22.9565H17.7391V17.7391Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39128 18.7826H14.6087V22.9565H9.39128V18.7826Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04346 21.913H6.26085V22.9565H1.04346V21.913Z",
    fill: "#313131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6441_460037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/Screen.85134f9988e9e56da2a6793781a09289.svg";
export { ForwardRef as ReactComponent };